<template>
  <v-menu z-index="999" offset-y :close-on-content-click="false" v-model="showNotifications">
    <template v-slot:activator="{ on, attrs }">
      <v-btn icon @click="showNotifications = !showNotifications" v-bind="attrs" v-on="on">
        <div class="notifications" v-if="notifications.length > 0">{{ notifications.length }}</div>
        <v-icon size="18">mdi-bell-outline</v-icon>
      </v-btn>
    </template>
    <v-card class="mx-auto">
      <v-toolbar color="#FFBA00" dark>
        <v-toolbar-title>Notificações</v-toolbar-title>

        <v-spacer></v-spacer>

        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-btn icon disabled>
              <v-icon v-on="on">mdi-checkbox-marked-circle</v-icon>
            </v-btn>
          </template>
          <div>
            Marcar tudo como lido
          </div>
        </v-tooltip>
        <v-btn icon @click="showNotifications = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>

      <v-list two-line>
        <template v-for="(notification, index) in notifications">
          <v-list-item :key="index">
            <v-list-item-content>
              <v-list-item-title v-text="notification.title"></v-list-item-title>

              <v-list-item-subtitle class="text--primary" v-text="item.headline"></v-list-item-subtitle>

              <v-list-item-subtitle v-text="notification.subtitle"></v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>

          <v-divider v-if="index < items.length - 1" :key="index"></v-divider>
        </template>

        <v-list-item v-if="notifications.length === 0">
          <v-list-item-content>
            <v-list-item-subtitle>Você não possui novas notificações</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-card>
  </v-menu>
</template>

<script>
export default {
  name: 'Notifications',
  data() {
    return {
      showNotifications: false,
      notifications: []
    }
  }
}
</script>

<style scoped>
.notifications {
  position: absolute;
  height: 12px;
  width: 12px;
  font-size: 0.5rem;
  border-radius: 50%;
  background-color: #ff0000;
  z-index: 5;
  margin-left: 1rem;
  top: 0;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
